import { carteOpportunitesMock, texteSeoMock, titreDescriptionMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(), carteOpportunitesMock, texteSeoMock()];

export const carteOpportunitesPageMock: SlugPage = {
  ...pageBase({
    title: 'Carte des opportunités',
    type: 'carte',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
